module.exports = __webpack_public_path__ + "static/media/dp-icon.973561e9.png";